export default __webpack_public_path__ + "audio/38f7140a71ce72e916bc3b2a400ba40a.mp3";